import setupCornerstone from "./setupCornerstone.js";
import appState from "./appState.js";
import getUrlForImageId from "./lib/getUrlForImageId.js";
import getMprUrl from "./lib/getMprUrl.js";
import MPR from "@/utils/MPR/MPR.class";

import { mat4 } from "gl-matrix";

async function kickstartApp() {
    // kickstartApp 激活
  // Setup
  const seriesNumber = MPR.seriesNumber || 0;

  const mprAxialSeriesElement = MPR.axialSeriesDom;
  const mprCoronalSeriesElement = MPR.coronalSeriesDom
  const mprSagittalSeriesElement =  MPR.sagittalSeriesDom

  setupCornerstone(seriesNumber);



  // Display original series

  // ~~ AXIAL
  // Image orientation patient (IOP)
  const axial = mat4.create();
  const axialIop = new Float32Array([
    axial[0],
    axial[1],
    axial[2],
    axial[4],
    axial[5],
    axial[6]
  ]);
  const axialIopAsString = axialIop.join();
  // const axialMprUrl = getMprUrl(axialIopAsString, "0,0,97.5");
  const axialMprUrl = getMprUrl(seriesNumber,axialIopAsString);
  cornerstone.loadAndCacheImage(axialMprUrl).then(image => {
    cornerstone.displayImage(mprAxialSeriesElement, image);
  });

  // ~~ CORONAL
  // Image orientation patient (IOP)
  const coronalIop = new Float32Array([1, 0, 0, 0, 0, -1]);
  const coronalIopAsString = coronalIop.join();
  // const coronalMprUrl = getMprUrl(coronalIopAsString, "0,69.3642578125,0");
  const coronalMprUrl = getMprUrl(seriesNumber,coronalIopAsString);

  cornerstone.loadAndCacheImage(coronalMprUrl).then(image => {
    cornerstone.displayImage(mprCoronalSeriesElement, image);
  });

      // ~~ SAGITTAL
    // Image orientation patient (IOP)
    const sagittalIop = new Float32Array([
      0, 1, 0,
      0, 0, -1
  ]);
  const sagittalIopAsString = sagittalIop.join();
  // const sagittalMprUrl = getMprUrl(sagittalIopAsString, "69.3642578125,0,0");
  const sagittalMprUrl = getMprUrl(seriesNumber,sagittalIopAsString);

  cornerstone.loadAndCacheImage(sagittalMprUrl).then(image => {
      cornerstone.displayImage(mprSagittalSeriesElement, image);
  });
}

export default kickstartApp;
